package com.essntl.features.area.domain.di

import org.koin.core.annotation.ComponentScan
import org.koin.core.annotation.Module

@Module
@ComponentScan("com.essntl.features.area.domain.usecase")
class AddEditAreaUseCaseModule